import React, { Dispatch, SetStateAction, useContext, useEffect, useMemo, useState } from "react";
import "./FilterBar.css"

import map from '../../../../image/map.webp'
import { TfiClose } from "react-icons/tfi";
import { Filter } from "../../../../components/filter/filter";
import { AppContext } from "../../../../context/AppContext";
import { GoSearch } from "react-icons/go";
import { FilterItem,listFilters,allShowFilter } from "../../../../components/types/types";
import { useNavigate } from "react-router-dom";
import MaskBackground from "../../../../components/maskBackground/maskBackground";
const filters: FilterItem[] = listFilters
interface FilterBarProps {
    setShowAll: Dispatch<SetStateAction<number>>,
    priceFilter: (min:number,max:number) => void,
    distanceFitler: (distance:number) => void,
    resetSearchResto:() => void,
}
const FilterBar:React.FC<FilterBarProps> = ({setShowAll,priceFilter,distanceFitler,resetSearchResto}) => {
  const {showFilterTel,setShowFilterTel,filterChoose,setFilterChoose,setPreferencesCookies,searchFilterValue,setSearchFilterValue,allPresentFilter} = useContext(AppContext)
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 767 && showFilterTel);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
    const {setShowCookies} = useContext(AppContext)
    const navigate = useNavigate()

    const currentListFilter = useMemo(() => {
    if (!allPresentFilter?.length) return filters;
    return filters.map((elem) => {
        if (["Distance","Prix par personne","Notes","Type de restaurant","Raccourci"].includes(elem.value)) {
        return elem;
        }
        return {
        ...elem,
        liste: elem.liste?.filter((x) => allPresentFilter.includes(x)) ?? [],
        };
    });
    }, [filters, allPresentFilter]);

  const closeFilter = () => {
      setShowFilterTel(false)
  }

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchFilterValue(event.target.value)      
  }

  const handleMap = () => {
    const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
    if (cookie) {
        const cookieValue = cookie.split('=')[1];
        try {
            const decode = decodeURIComponent(cookieValue)
            const cookieData = JSON.parse(decode);
            if (cookieData['perform-analytics']) {
                setShowFilterTel(false)
                navigate(`/map?via=home`);
            } else {
                setShowCookies(true)
                setPreferencesCookies(true)
            }
        } catch (error) {
            setShowCookies(true)
            setPreferencesCookies(true)
        }
    } else {
        setShowCookies(true)
        setPreferencesCookies(true)
    }
  }
    const [touchStartX, setTouchStartX] = useState<number | null>(null);
    const [touchEndX, setTouchEndX] = useState<number | null>(null);
    const [isSlidingOut, setIsSlidingOut] = useState(false);


    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const target = e.target as HTMLElement;
        if (target.tagName.toLowerCase() === 'input' && target.getAttribute('type') === 'range') {
            return;
        }
        setTouchStartX(e.changedTouches[0].clientX);
    };
    
    
    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        const target = e.target as HTMLElement;
        if (target.tagName.toLowerCase() === 'input' && target.getAttribute('type') === 'range') {
            return;
        }
        setTouchEndX(e.changedTouches[0].clientX);
    };
    
    
    const handleTouchEnd = () => {
        if (touchStartX !== null && touchEndX !== null) {
            const swipeDistance = touchStartX - touchEndX;
            if (swipeDistance > 80) { 
                triggerSlideOut();
            }
        }
        setTouchStartX(null);
        setTouchEndX(null);
    };

    const triggerSlideOut = () => {
        setIsSlidingOut(true);
        setTimeout(() => {
            setIsSlidingOut(false); 
            closeFilter(); 
        }, 300);
    };
    
    
    

    return (
       <div
            className={`containerFilterBar ${!showFilterTel && 'notShowTel'} ${isSlidingOut ? 'slideOutLeft' : ''}`}
            id="containerFilterBar"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >

            {isMobile && <div className="maskForPhone"><MaskBackground /></div> }
            <div className='filterBar' style={{color:'white'}} >
                
                <div className="closeFilterOnglet" >
                    <p className="largeTitle">Filtres</p>
                    <TfiClose size={20} style={{marginRight:'5%'}} onClick={triggerSlideOut}/>
                </div>
                <div className="borderFilterOnglet"></div>
                <div className="mainCorp">
                    <div className="map"onClick={handleMap} >
                        <p className="smallTextBold pointer" style={{color:'black'}}>Voir la map</p>
                        <img src={map}  loading="lazy" alt="map"/>
                    </div>
                    <div className={`containerInputFilter ${searchFilterValue ? 'isSearch' : ''}`}>      
                            <GoSearch className="searchIcon" color="black" size={15} />
                            <GoSearch className="searchIconPhone" color="black" size={20} />
                            <input type="search" className="inputFilter XsmallText" placeholder="Rechercher un filtre..." value={searchFilterValue} onChange={handleSearch} style={{backgroundColor:"transparent"}} maxLength={50}/>
                            {searchFilterValue &&  <TfiClose className="resetIcon forComputer"  size={17} onClick={() => setSearchFilterValue("")}/> }
                            
                            {searchFilterValue &&  <div className="containerReset" onClick={() => setSearchFilterValue("")}><TfiClose className="resetIcon forPhone"  size={17} /></div> }
                    </div>
                    {
                    !searchFilterValue && filterChoose.length > 0?
                    <Filter baseClose={true} checkPrice={priceFilter} resetSearchResto={resetSearchResto} checkDistance={distanceFitler} value={`Mes filtres (${filterChoose.length})`} liste={filterChoose as string[]} setShowAll={setShowAll} allDelete={true} searchValue={searchFilterValue} listFilter={filterChoose} setListFilter={setFilterChoose} />
                    :
                    !searchFilterValue &&<><><p className='smallTextBold' style={{marginBottom:'5px'}}>Aucun filtre sélectionné</p><p className=' XsmallText textNoFilter'>Affinez votre recherche et découvrez !</p></><div className="separator"></div></>   
                    }
                    <div className="listeFilter" >            
                        {currentListFilter && currentListFilter.map((filter, index) => (
                            (filter.liste?.length || allShowFilter.includes(filter.value)) ? 

                            <Filter
                                key={index}
                                checkPrice={priceFilter}
                                checkDistance={distanceFitler}
                                value={filter.value}
                                liste={filter.liste || [] }
                                setShowAll={setShowAll}
                                searchValue={searchFilterValue}
                                listFilter={filterChoose}
                                setListFilter={setFilterChoose}
                            />

                            : undefined
                        ))}      
                    </div>
                </div>
            </div> 
        
        </div>
    )
}

export default FilterBar